var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.drawerVisible,
        "with-header": false,
        size: "500px",
        direction: "rtl",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "ad-group-detail-container" }, [
        _c("div", { staticClass: "drawer-header" }, [
          _c("div", { staticClass: "drawer-title" }, [_vm._v("广告组详情")]),
          _c("i", {
            staticClass: "el-icon-close close-icon",
            on: { click: _vm.handleClose },
          }),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "detail-content",
          },
          [
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("基本信息")]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [
                  _vm._v("广告组名称"),
                ]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.name || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("位置模板")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.adTemplateName || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("展示界面")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.pageTitle)),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("权重")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.weights || "-")),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("其他信息")]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("创建人")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.createUserName || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("创建时间")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.createTime || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("审核人")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.auditUserName || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("审核时间")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.auditTime || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("更新人")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.updateUserName || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("更新时间")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.adGroupInfo.updateTime || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("状态")]),
                _c("div", { staticClass: "item-value" }, [
                  _c(
                    "span",
                    {
                      class: ["status-text", "status-" + _vm.adGroupInfo.state],
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.adGroupInfo.stateStr || "-") +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm.adGroupInfo.state === 2
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("div", { staticClass: "item-label" }, [
                      _vm._v("拒绝原因"),
                    ]),
                    _c("div", { staticClass: "item-value red-text" }, [
                      _vm._v(_vm._s(_vm.adGroupInfo.rejectReason)),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }